import palette from '../palette';
import typography from '../typography';

export default {
   styleOverrides: {
      root: {
         fontWeight: 'normal',
      },
      head: {
         color: palette.primary.main,
         fontWeight: 500,
         fontSize: 14
      },
   }
};
